var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.7 396.3",
    style: {
      enableBackground: "new 0 0 494.7 396.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.9,386.3c-0.5,0-1,0-1.4-0.1c-5.2-0.8-8.8-5.7-8-10.9l54.2-357.5c0.8-5.2,5.7-8.8,10.9-8 c5.2,0.8,8.8,5.7,8,10.9l-54.2,357.5C228.6,382.9,224.5,386.3,219.9,386.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.3,342c-2.6,0-5.1-1-7-3.1L15.3,206c-3.4-3.7-3.4-9.3,0-13L138.3,59.8c3.6-3.9,9.6-4.1,13.5-0.5 c3.9,3.6,4.1,9.6,0.5,13.5L35.3,199.5L152.3,326c3.6,3.9,3.3,9.9-0.5,13.5C150,341.1,147.7,342,145.3,342z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.5,342c-2.3,0-4.6-0.8-6.5-2.5c-3.9-3.6-4.1-9.6-0.5-13.5l117.1-126.5L341.5,72.8 c-3.6-3.9-3.3-9.9,0.5-13.5c3.9-3.6,9.9-3.3,13.5,0.5L478.6,193c3.4,3.7,3.4,9.3,0,13l-123.1,133C353.7,341,351.1,342,348.5,342z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.084de79a.svg";
export { ForwardRef as ReactComponent };